import React, { useEffect, useState } from "react";
import ToggleDetails from "./ToggleDetails";
import { useDispatch, useSelector } from "react-redux";
import GoodsOverview from "./GoodsManagment/GoodsOverview";
import GoodsInCard from "./GoodsIn/GoodsInCard";
import GoodsoutCard from "./GoodsOut/GoodsoutCard";

function Dashboard() {
  const Status = useSelector(
    (state) => state.statistics.GoodsStatsToggleStatus
  );
  return (
    <>
      <div className="flex flex-col max-w-5xl mt-2 mb-5 xl:max-w-7xl">
        <div>
          <h2 className="font-Montserrat text-xl font-bold text-black">
            Goods In/Out Dashboard
          </h2>
          <div className="border-b-2 border-blue-200 w-20"></div>
        </div>
        <ToggleDetails />
        {Status === "Overview" ? <GoodsOverview /> : null}
        {Status === "Goods In" ? <GoodsInCard /> : null}
        {Status === "Goods Out" ? <GoodsoutCard /> : null}
      </div>
    </>
  );
}

export default Dashboard;
